import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "../../components/site/Logo";
import { api, errMsg } from "../../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      toast.success("Bentornata!");
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };
  return (
    <main data-testid="admin-login-page" className="min-h-screen grid lg:grid-cols-2 bg-cream">
      <div className="hidden lg:block relative">
        <img src="/img/w5.jpg" alt="" className="absolute inset-0 w-full h-full object-cover" />
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm">
          <Logo />
          <h1 className="mt-10 font-serif text-4xl text-ink">Area riservata</h1>
          <p className="mt-2 text-ash text-sm">Gestisci portfolio, creazioni e richieste.</p>
          <label className="block mt-8 font-mono text-[11px] uppercase tracking-[0.22em] text-ash">Email</label>
          <input data-testid="admin-email-input" type="email" required className="field mt-2" value={email} onChange={(e) => setEmail(e.target.value)} />
          <label className="block mt-5 font-mono text-[11px] uppercase tracking-[0.22em] text-ash">Password</label>
          <input data-testid="admin-password-input" type="password" required className="field mt-2" value={password} onChange={(e) => setPassword(e.target.value)} />
          {error && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-700">{error}</p>}
          <button data-testid="admin-login-button" disabled={loading} className="mt-8 w-full rounded-full bg-cypress text-cream py-3 text-sm hover:bg-terra transition-colors disabled:opacity-60">{loading ? "Accesso…" : "Accedi"}</button>
        </form>
      </div>
    </main>
  );
}
